module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_7.6abe300d.png";